import { Temporality } from "./../model/temporality";
import { UserDetailsService } from "./../../login/services/UserDetails.service";
import { SaveUpdateNoticeDto } from "./../model/SaveUpdateNoticeDto";
import { FileLikeObject, FileUploader } from "ng2-file-upload";
import {
  Component,
  OnInit,
  ViewChild,
  Inject,
  LOCALE_ID,
  AfterViewInit,
  OnDestroy,
  inject,
  signal,
  viewChild,
  computed,
  effect,
  DestroyRef,
} from "@angular/core";
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators, FormGroup } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { UpdateNoticeService } from "../service/updatenotice.service";
import { DatePipe } from "@angular/common";
import { saveAs } from "file-saver";
import { MatDialog } from "@angular/material/dialog";
import { RejectUnDialogComponent } from "../reject-un-dialog/reject-un-dialog.component";
import { EditDateValidation } from "./EditDateValidation";
import { AixmFeatureDTO } from "../../info-management/model/AixmFeatureDTO";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ChangeSummary } from "../../info-management/model/ChangeSummary";
import { DeleteItemDialogComponent } from "../delete-item-dialog/delete-item-dialog.component";
import moment from "moment";
import { environment } from "../../../environments/environment";
import { ConfigService } from "../../utils/config.service";
import { MapViewDialogComponent } from "../../info-management/map-view-dialog/map-view-dialog.component";
import { UploadDatasetDialogComponent } from "../../info-management/upload-dataset-dialog/upload-dataset-dialog.component";
import { ConfirmationDialogComponent } from "../confirmation-dialog/confirmation-dialog.component";
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from "@angular/material-moment-adapter";
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from "@angular/material/core";
import { MatCalendarCellClassFunction } from "@angular/material/datepicker";
import {
  concatMap,
  debounceTime,
  delay,
  distinctUntilChanged,
  filter,
  map,
  startWith,
  switchMap,
  takeUntil,
  tap,
} from "rxjs/operators";
import { MatSelectChange } from "@angular/material/select";
import { BehaviorSubject, of, Subject } from "rxjs";
import { InfoManagementService } from "src/app/info-management/service/info-management.service";
import { takeUntilDestroyed, toSignal } from "@angular/core/rxjs-interop";
import { setLoader } from "src/app/utils/set-loaders";
import { AisProduct } from "src/app/shared/enums/AisProducts";
import { DefaultFormComponent } from "src/app/shared/default-form/default-form.component";
import { UpdateNoticeDetailsDTO } from "../model/UpdateNoticeDetailsDTO";
import { CreateUpdateNoticeDTO } from "../model/CreateUpdateNoticeDTO";
import { UpdateNoticeSummaryDTO } from "../model/UpdateNoticeSummaryDTO";
import { AiracType } from "src/app/shared/enums/AiracTypes";
import { NotamType } from "src/app/shared/enums/NotamTypes";

export const MY_FORMATS = {
  parse: {
    dateInput: "LL",
  },
  display: {
    dateInput: "DD MMM YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-edit-updatenotice",
  // templateUrl: './edit-updatenotice.component.html',
  templateUrl: "./edit-updatenotice-revamp-two.component.html",
  styleUrls: ["./edit-updatenotice.component.css"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class EditUpdateNoticeComponent implements OnInit, AfterViewInit {
  private _destroyRef = inject(DestroyRef);

  private _loaders$ = new BehaviorSubject({});

  loaders = toSignal(this._loaders$.asObservable());

  private _infoManagementService = inject(InfoManagementService);

  private _route = inject(ActivatedRoute);

  isDp: boolean = ConfigService.settings.isDataProvider;

  isAis: boolean = ConfigService.settings.isAis;

  isUnReader: boolean = ConfigService.settings.isUnReader;

  enableValidation = ConfigService.settings.enableValidation;

  private role = ConfigService.settings.role;
  editUNForm: UntypedFormGroup;
  isloaded: boolean = false;
  clicked: string;
  public uploader: FileUploader = new FileUploader({ url: "" });
  validEffDate: Date = new Date();
  validCancelDate: Date = new Date();
  //status: string = this.editUNForm.get['status'].value

  unName: string;
  selectedRowIndex;
  correctionNumber: number;
  lastDate: string;
  userName: string;
  dueDate: any = null;
  effectiveDate: string;
  cancelDate: string;
  assignedUser: boolean;
  isDirty: boolean = false;
  isDeleted: boolean = false;
  isUndo: boolean = false;
  fileIndex: number;
  noticeDay = environment.noticeNumber;
  latitude: number;
  longitude: number;
  unId: string;
  featureId: string;
  featuresExist: boolean;

  fileNames: string[] = [];
  fileNamesToDelete: string[] = [];

  aixmDtos: AixmFeatureDTO[] = [];
  deletion = ChangeSummary.DELETION;
  aixmFeatures: AixmFeatureDTO[] = [];

  updateNoticeId: string = this._route.snapshot.params["id"];

  localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  //datasoure for table
  aixmFeatures_DataSource = new MatTableDataSource<AixmFeatureDTO>(this.aixmDtos);

  displayedColumns = ["featureType", "featureName", "summary", "lastEdited", "delete_icon"];
  //sorting
  @ViewChild(MatSort) sort: MatSort;
  //pagination
  @ViewChild(MatPaginator) paginator: MatPaginator;

  // updateNotice: UpdateNoticeDetailsDTO = null;

  showAipText = signal(false);

  defaultFormComponent = viewChild(DefaultFormComponent);

  displayDueDateSection = false;

  dueDateControl = new FormControl({ value: "", disabled: true });

  defaultForm: FormGroup;

  aisProduct = AisProduct;

  selectedAisProduct = computed(() => this.defaultFormComponent()?.selectedAisProduct?.value);

  updateNotice = toSignal(
    this.updatenoticeService.getUpdateNotice(this.updateNoticeId).pipe(
      setLoader(this._loaders$, "getUpdateNotice"),
      map((result) => {
        const parsed = UpdateNoticeDetailsDTO.parse(result);
        console.log(parsed, "### UPDATE NOTICE DETAILS DTO");
        console.log(result, "### RAW RESULT");
        return parsed;
      }),
      tap((parsed) => {
        this.correctionNumber = parsed.timeSliceId.correction;
        this.defaultFormComponent().uploadedFiles = parsed.fileNames;
        this.defaultForm.get("effectiveDate").disable();
      }),
    ),
  );

  hasAssignee = toSignal(
    this.updatenoticeService
      .checkTaskIsClaimedByCurrentUser(this.updateNoticeId)
      .pipe(map((result) => (this.isAis ? true : result))),
  );

  ableToSave = computed(() => {
    const formValid = this.defaultFormComponent().formValid();
    const formDirty = this.defaultFormComponent().formDirty();
    const states = [
      { state: "form_valid_dirty", condition: formValid && formDirty },
      { state: "attachments_modified", condition: this.defaultFormComponent().attachmentsModified() },
    ];
    return states.some((state) => state.condition);
  });

  isInEdit = computed(() => {
    const updateNotice = this.updateNotice();
    const editStatuses = ["task_edit_change_request", "Editable"];
    return editStatuses.includes(updateNotice?.status);
  });

  isInReview = computed(() => {
    const updateNotice = this.updateNotice();
    return ["task_saf_review", "task_nof_review", "task_ais_review", "AIS-Review"].includes(updateNotice?.status);
  });

  isInReviewerRoles = computed(() => {
    const isAisAdminOrAisReviewer = [this.role.role_Ais_Admin, this.role.role_Ais_Reviewer].some((role) => {
      return this.userDetailsService.hasRole(role);
    });
    const states = [
      { status: "task_saf_review", requiredRole: this.userDetailsService.hasRole(this.role.role_Saf_Reviewer) },
      { status: "task_nof_review", requiredRole: this.userDetailsService.hasRole(this.role.role_Nof_Reviewer) },
      { status: "task_ais_review", requiredRole: this.userDetailsService.hasRole(this.role.role_Ais_Reviewer) },
      { status: "AIS-Review", requiredRole: this.userDetailsService.hasRole(this.role.role_Ais_Reviewer) },
    ];
    return states.some(
      (state) => (state.requiredRole || isAisAdminOrAisReviewer) && this.updateNotice()?.status === state.status,
    );
  });

  isPublishedOrCancelled = computed(() => {
    const updateNotice = this.updateNotice();
    return [
      "end_implemented_with_perm_notam",
      "end_implemented",
      "end_notam_request_accepted",
      "end_cancelled",
      "Published",
      "Cancelled",
    ].includes(updateNotice?.status);
  });

  ableToRead = computed(() => {
    const hasAssignee = this.hasAssignee();
    const isPublishedOrCancelled = this.isPublishedOrCancelled();

    // If status is Published or Cancelled, then can't read
    if (isPublishedOrCancelled) {
      return false;
    }

    // If there's assigned user, then can read
    if (hasAssignee) {
      return true;
    }

    // If no current user being assigned, but having DP and UN Reader role, then can read
    if (!hasAssignee && this.isDp && this.isUnReader) {
      return true;
    }

    // If no current user being assigned, and having AIS admin role, then can read
    if (!hasAssignee && this.isAis) {
      return true;
    }
  });

  formReadonly = computed(() => {
    const hasAssignee = this.hasAssignee();
    const isInReview = this.isInReview();
    const isInEdit = this.isInEdit();
    const states = [
      { state: "when_has_no_assignee", condition: !hasAssignee },
      { state: "when_in_review", condition: isInReview },
      { state: "when_in_edit_without_assignee", condition: isInEdit && !hasAssignee },
    ];
    return states.some((state) => state.condition);
  });

  formDisabled = computed(() => {
    const isPublishedOrCancelled = this.isPublishedOrCancelled();
    return isPublishedOrCancelled;
  });

  /**
   * Set the sort after the view init since this component will
   * be able to query its view for the initialized sort.
   */
  ngAfterViewInit() {
    this.aixmFeatures_DataSource.sort = this.sort;
    this.aixmFeatures_DataSource.paginator = this.paginator;
  }

  //filter rows
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.aixmFeatures_DataSource.filter = filterValue;
  }

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private route: ActivatedRoute,
    public router: Router,
    private fb: UntypedFormBuilder,
    public dialog: MatDialog,
    public updatenoticeService: UpdateNoticeService,
    private userDetailsService: UserDetailsService,
    private _snackBar: MatSnackBar,
  ) {
    this.unId = this.route.snapshot.params["unId"];

    effect(() => {
      this.defaultForm = this.defaultFormComponent().form;
    });
  }

  ngOnInit() {
    console.log("### INIT");
    this.validEffDate.setDate(this.validEffDate.getDate() + ConfigService.settings.periodToCalculateValidEffDate);
    this.validCancelDate.setDate(
      this.validCancelDate.getDate() + ConfigService.settings.periodToCalculateValidEffDate + 1,
    );

    this.getAixmFeatures(this.updateNoticeId);
    let maxFileSize = 1 * 1024 * 1024;
    this.uploader = new FileUploader({
      url: "",
      maxFileSize: maxFileSize,
    });

    this.uploader.onWhenAddingFileFailed = (item, filter) => {
      let message = "";
      switch (filter.name) {
        case "fileSize":
          message =
            'Error! \nThe uploaded file "' +
            item.name +
            '" is ' +
            this.formatBytes(item.size) +
            ", this exceeds the maximum allowed size of " +
            this.formatBytes(maxFileSize) +
            ".";
          break;
        default:
          message = 'Error trying to upload file "' + item.name + '".';
          break;
      }
      this.openSnackBar(message, "");
    };
  }

  REFERENCE_AIRAC_DATE = moment("2018-11-08");
  AIRAC_CYCLE_DAYS = 28;

  formatBytes(bytes, decimals?) {
    if (bytes == 0) return "0 Bytes";
    const k = 1024,
      dm = decimals || 2,
      sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
    });
  }

  getAixmFeatures(eventId: string): void {
    this.updatenoticeService.getAixmFeatures(eventId).subscribe((res) => {
      this.aixmDtos = res;
      this.aixmFeatures = [];

      for (let i = 0; i < res.length; i++) {
        //if (res[i].summary != "Deleted Change") {
        this.aixmFeatures.push(res[i]);
        //}
      }
      if (this.aixmFeatures.length == 0) {
        this.featuresExist = false;
      } else {
        this.featuresExist = true;
      }

      if (this.isAISReviewer() == false) {
        this.aixmFeatures_DataSource.data = res;
      } else {
        this.aixmFeatures_DataSource.data = this.aixmFeatures;
        console.log(this.aixmFeatures_DataSource, "### this.aixmFeatures_DataSource");
      }
    });
  }

  generateDraftAISProduct() {
    this.updatenoticeService
      .generateDraftAISProduct(this.updateNoticeId)
      .pipe(
        concatMap((path) => {
          return this.updatenoticeService.downloadDraftAISProduct(path).pipe(map((blob) => ({ blob, path })));
        }),
        takeUntilDestroyed(this._destroyRef),
      )
      .subscribe((result) => {
        const { blob, path } = result;
        saveAs(blob, path.substring(path.lastIndexOf("/") + 1));
      });
  }

  isReadOnly(): boolean {
    if (this.isDp && this.assignedUser) {
      // this.editUNForm.get("temporality").enable();
      return false;
    } else {
      // this.editUNForm.get("temporality").disable();
      return true;
    }
  }

  checkAssignedUser(): void {
    this.updatenoticeService.checkTaskIsClaimedByCurrentUser(this.updateNoticeId).subscribe((result) => {
      this.assignedUser = this.isAis ? true : result;
    });
  }

  isAISReviewer(): boolean {
    return this.userDetailsService.hasRole(this.role.role_Ais_Reviewer);
  }

  openCancelDialog(itemId: string): void {
    let dialogRef = this.dialog.open(DeleteItemDialogComponent, {
      width: "500px",
      data: { featureId: this.updateNoticeId, itemId: itemId },
    });

    dialogRef.componentInstance.onAdd.subscribe((result) => {
      console.log("The result is " + JSON.stringify(result));
      if (JSON.stringify(result)) this.ngOnInit();
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("After the dialog was closed:" + result);
    });
  }

  /*   highlight(row) {
      console.log("The id is "+ row.id);
      if(row.id = 1){
      this.selectedRowIndex = row.id;
    }
  } */

  showMap() {
    if (this.effectiveDate == undefined) {
      this.effectiveDate = this.defaultForm.get("effectiveDate").getRawValue();
    }
    let dialogRef = this.dialog.open(MapViewDialogComponent, {
      data: {
        aixmDtos: this.aixmDtos,
        unId: this.updateNoticeId,
        latitude: this.latitude,
        longitude: this.longitude,
        effectiveDate: this.effectiveDate,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed");
      console.log("After the dialog was closed:" + result);
    });
  }

  openDialog(): void {
    let dialogRef = this.dialog.open(UploadDatasetDialogComponent, {
      width: "500px",
      data: { unId: this.updateNoticeId },
    });

    dialogRef.componentInstance.onAdd.subscribe((result) => {
      console.log("The result is " + JSON.stringify(result));
      this.getAixmFeatures(this.updateNoticeId);
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed" + result);
    });
  }

  navigateToValidationReport() {
    this._infoManagementService
      .getUpdateNoticeValidation(this.updateNoticeId)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(() => {
        this.router.navigate(["change-request", this.updateNoticeId, "validation-report"]);
      });
  }

  navigateToValidationHistory(): void {
    // this.router.navigate(['change-request', this.updateNoticeId, 'validation-history']);
    this.router.navigate(["change-request", this.updateNoticeId, "validation-report"]);
  }

  // Update Notice Actions
  saveChanges(): void {
    this.defaultForm.controls["airacType"].markAsDirty();
    const parsed = CreateUpdateNoticeDTO.parse(this.defaultForm.getRawValue());
    const changedProperties = Object.keys(parsed).reduce((accumulator, key) => {
      const currentControl = this.defaultForm.get(key);
      if (currentControl?.dirty) {
        accumulator[key] = parsed[key];
      }
      return accumulator;
    }, {} as CreateUpdateNoticeDTO);

    const saveUpdateNoticeDto: SaveUpdateNoticeDto = {
      featureId: this.updateNoticeId,
      baseCorrection: this.correctionNumber,
      changedProperties: changedProperties as any,
    };

    const uploadedFiles = this.defaultFormComponent().uploader.queue.map((fileItem) => fileItem.file);
    const filesToBeDeleted = this.defaultFormComponent().filesToBeDeleted;
    console.log(saveUpdateNoticeDto);
    this.updatenoticeService
      .editUpdateNotice(saveUpdateNoticeDto, uploadedFiles, filesToBeDeleted)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((result) => {
        this.correctionNumber = result.correction;
        this.router.navigate(["/change-requests"]);
      });
  }

  submitChanges(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "500px",
      data: {},
    });
    dialogRef
      .afterClosed()
      .pipe(
        filter((confirm) => !!confirm),
        switchMap(() => this.updatenoticeService.submitToAIS(this.updateNoticeId)),
        takeUntilDestroyed(this._destroyRef),
      )
      .subscribe(() => this.router.navigate(["/change-requests"]));
  }

  acceptChanges(): void {
    this.updatenoticeService
      .acceptUN(this.updateNoticeId)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(() => {
        this.router.navigate(["/change-requests"]);
      });
  }

  rejectChanges(): void {
    this.dialog.open(RejectUnDialogComponent, {
      width: "500px",
      data: { id: this.updateNoticeId },
    });
  }

  deleteUpdateNotice(): void {
    this.updatenoticeService
      .deleteUN(this.updateNoticeId)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((result) => {
        this.router.navigate(["/change-requests"]);
      });
  }

  restoreUpdateNotice(): void {
    this.updatenoticeService
      .restoreUpdateNotice(this.updateNoticeId)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(() => {
        this.openSnackBar("Update Notice restored successfully", "Close");
        this.defaultForm.enable();
        this.defaultForm.markAsPristine();
        this.router.navigate(["/change-requests"]);
      });
  }

  finishNofPermNotam() {
    this.updatenoticeService
      .finishNofPermNotam(this.updateNoticeId)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((result) => {
        this.router.navigate(["/change-requests"]);
      });
  }

  download(fileName: string) {
    this.updatenoticeService
      .download(this.updateNoticeId, fileName)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((blob) => {
        saveAs(blob, fileName);
      });
  }

  onAisProductChange(aisProduct: AisProduct) {
    const temporalityLookup = {
      [AisProduct.AMDT]: Temporality.PERMANENT,
      [AisProduct.SUP]: Temporality.TEMPORARY,
      [AisProduct.NOTAM]: Temporality.TEMPORARY,
      [AisProduct.AIC]: Temporality.PERMANENT,
    };

    const partialProp: Partial<UpdateNoticeSummaryDTO> = {
      aisProduct,
      airacType: aisProduct === AisProduct.AMDT ? AiracType.NON_AIRAC : AisProduct.SUP ? AiracType.AIRAC : null,
      temporality: temporalityLookup[aisProduct],
      notamType: aisProduct === AisProduct.NOTAM ? NotamType.N : null,
    };

    const parsedProduct = UpdateNoticeSummaryDTO.parse({
      ...this.defaultForm.getRawValue(),
      ...partialProp,
    });

    this.defaultForm.patchValue(parsedProduct);
    Object.keys(partialProp).forEach((key) => {
      this.defaultForm.get(key).markAsDirty();
    });
  }

  toggleAipText(): void {
    this.defaultFormComponent().selectedAisProduct;
    this.showAipText.update((current) => !current);
  }

  onDueDateChange(event: string): void {
    console.log(event, "### Due date emitted from default form component");
    this.dueDateControl.setValue(event);
  }
}
